/**
 * Home Page Sections Configuration
 *
 * Section order:
 * COVER (photographic entrance + table of contents) → WHAT WE DO → PROCESS
 * → EXPERIENCE → WHY OCEANNOVA → SHIPPING & LOGISTICS → INFORMATION & CONTACT
 */

import FloatingChrome from "@/components/nav/FloatingChrome";
import SectionIndex from "@/components/nav/SectionIndex";
import HomeCover from "@/components/HomeCover";
import Offerings from "@/components/home/Offerings";
import Process from "@/components/home/Process";
import SelectedExperience from "@/components/home/SelectedExperience";
import WhyOceanNova from "@/components/home/WhyOceanNova";
import ShippingLogistics from "@/components/home/ShippingLogistics";
import HomeCTA from "@/components/home/HomeCTA";
import Footer from "@/components/Footer";
import { PageSection } from "@/types/sections";

export const homeSections: PageSection[] = [
  { id: "chrome", component: FloatingChrome, category: "navigation" },
  { id: "section-index", component: SectionIndex, category: "navigation" },
  { id: "cover", component: HomeCover, category: "hero" },
  { id: "offerings", component: Offerings, category: "content" },
  { id: "process", component: Process, category: "content" },
  { id: "selected-experience", component: SelectedExperience, category: "content" },
  { id: "why-oceannova", component: WhyOceanNova, category: "content" },
  { id: "shipping-logistics", component: ShippingLogistics, category: "content" },
  { id: "home-cta", component: HomeCTA, category: "content" },
  { id: "footer", component: Footer, category: "footer" },
];
